export default "__VITE_ASSET__Cm_54U3Q__"